export default {
  data() {
    return {
      orderStatuses: [
        { value: "pending", icon: "mdi-clock-outline" },
        { value: "accepted", icon: "mdi-check" },
        { value: "in-progress", icon: "mdi-progress-clock" },
        { value: "ready", icon: "mdi-food" },
        { value: "on-hold", icon: "mdi-pause" },
        { value: "delivered", icon: "mdi-truck-check" },
        { value: "completed", icon: "mdi-check-all" },
        { value: "cancelled", icon: "mdi-cancel" },
      ],
      prepTimeDialogOpen: false,
      prepTimeTarget: null,
    };
  },
  methods: {
    // Accepting an order asks for a prep time first, same as on the kitchen
    // display board - either "ready immediately" or "ready in X minutes".
    // Every other status change goes straight through.
    requestStatusChange(order, guest, newStatus) {
      if (newStatus === "accepted") {
        this.prepTimeTarget = { order, guest };
        this.prepTimeDialogOpen = true;
        return;
      }
      this.$emit("change-status", { order, guest, newStatus });
    },
    confirmPrepMinutes() {
      this.$emit("change-status", {
        order: this.prepTimeTarget.order,
        guest: this.prepTimeTarget.guest,
        newStatus: "accepted",
      });
      this.prepTimeDialogOpen = false;
      this.prepTimeTarget = null;
    },
    confirmReadyNow() {
      this.$emit("change-status", {
        order: this.prepTimeTarget.order,
        guest: this.prepTimeTarget.guest,
        newStatus: "ready",
      });
      this.prepTimeDialogOpen = false;
      this.prepTimeTarget = null;
    },
    isAsapOrder(order) {
      return !!(order && order.delivery_type === 0 && !order.delivery_time);
    },
    formatOrderTime(order) {
      if (!order) return "";
      if (order.delivery_time) {
        return order.delivery_time.substring(0, 5);
      }
      if (this.isAsapOrder(order) && order.created_at) {
        return new Date(order.created_at).toLocaleTimeString("sr-Latn", {
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      return "";
    },
    getStatusColors(status) {
      const statusColors = {
        pending: { fg: "#92620a", bg: "#fbeed2" },
        accepted: { fg: "#1d4ed8", bg: "#e3ebfc" },
        "in-progress": { fg: "#0e7c86", bg: "#ddf3f4" },
        ready: { fg: "#6d28d9", bg: "#eee4fb" },
        // isti prevod na srpskom ("Na čekanju") kao "pending", pa ista boja radi doslednosti
        "on-hold": { fg: "#92620a", bg: "#fbeed2" },
        delivered: { fg: "#157f3c", bg: "#e0f5e6" },
        completed: { fg: "#157f3c", bg: "#e0f5e6" },
        cancelled: { fg: "#b42318", bg: "#fae3e1" },
        deleted: { fg: "#b42318", bg: "#fae3e1" },
      };
      return statusColors[status] || { fg: "#55606b", bg: "#eaecee" };
    },
    statusChipStyle(status) {
      const colors = this.getStatusColors(status);
      return { backgroundColor: colors.bg, color: colors.fg };
    },
    statusDotStyle(status) {
      return { backgroundColor: this.getStatusColors(status).fg };
    },
    orderSubtotal(order) {
      if (!order || !order.order_guest_transactions) return 0;
      return order.order_guest_transactions.reduce(
        (sum, transaction) => sum + transaction.price * transaction.quantity,
        0
      );
    },
    calculateTotal(item) {
      if (!item.orders_guest || !item.orders_guest.length) return 0;

      let total = 0;
      item.orders_guest.forEach((order) => {
        if (order.order_guest_transactions) {
          order.order_guest_transactions.forEach((transaction) => {
            total += transaction.price * transaction.quantity;
          });
        }
      });

      return total;
    },
  },
};
